import highlightsUtil from '../../Utils/highlightsUtil'

export const HighlightText = ({ text, highlights = [] }) => {
    return (
        <>
            {highlightsUtil(text, highlights, '', { fontWeight: 'bold' })}
        </>
    )
}